import { ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection, isDevMode } from '@angular/core';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { provideKsgUi } from '@ksg/ui';
import { provideTransloco } from '@jsverse/transloco';

import { routes } from './app.routes';
import { authInterceptor } from './core/auth/auth.interceptor';
import { AuthService } from './core/auth/auth.service';
import { TranslocoHttpLoader } from './transloco-loader';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }),
    ),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor]), withInterceptorsFromDi()),
    // Sesja Electrona leży w zaszyfrowanym magazynie procesu głównego, a odczyt stamtąd
    // jest asynchroniczny. Musi się zakończyć przed pierwszą nawigacją routera (ta idzie
    // dopiero z APP_BOOTSTRAP_LISTENER), inaczej authGuard odesłałby zalogowanego
    // kasjera na ekran logowania.
    provideAppInitializer(() => inject(AuthService).restoreSession()),
    ...environment.mockProviders,
    provideKsgUi(),
    provideTransloco({
      config: {
        availableLangs: environment.languages,
        defaultLang: environment.defaultLanguage,
        fallbackLang: environment.defaultLanguage,
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
        missingHandler: { useFallbackTranslation: true },
      },
      loader: TranslocoHttpLoader,
    }),
  ],
};
